<template>
    <van-popup v-model="show" position="right" style="width: 100%;height: 100%;">
        <van-row style="padding-bottom: 47px">
            <van-nav-bar fixed left-arrow left-text="返回" :title="title" @click-left="show=false">
            </van-nav-bar>
        </van-row>
        <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="onLoad">
            <van-search v-model="value" placeholder="请输入处理人" @input="onSearch"/>
            <van-cell
                    style="padding: 20px"
                    v-for="item in users"
                    is-link
                    @click="selectUser(item)"
                    center>
                <div class="van-radio">
                                <span class="van-radio__label">
                                    <div class="van-address-item__name">{{item.realName}} <span>{{item.tel}}</span></div>
                                    <div class="van-address-item__address"
                                         style="font-size: 12px;color: #7d7e80;">所属部门：<span>{{item.companyName}}</span></div>
                                </span>
                </div>
            </van-cell>
        </van-list>
    </van-popup>

</template>

<script>
    import { getUsers } from '@/api/loanInfo'
    import { eventBus } from '@/vue/utils/eventBus'
    import { cloneDeep } from 'lodash'
    import { mapGetters } from 'vuex'

    export default {
        name: 'sys_user',
        props: {
            applyId: {
                type: String,
                default: ''
            }
        },
        watch: {
           /* 'remark'(val) {
                if (val == undefined || val.length > 0) {
                    this.remarkErr = ''
                }
            }*/
        },
        components: {},
        computed: mapGetters([
            'auditStatus',
            'applyInfo',
            'userId',
            'userName',
            'name'
        ]),
        data() {
            return {
                title: '',
                show: false,
                loading: false,
                finished: false,
                users: [],
                value:'',
                usersClone:[],
            }
        },
        mounted() {
            let self = this
            //初始化触发事件
            eventBus.$on('sys-user-popup', function (data) {
                self.show = true
                self.title = data.title
            })

        },
        destroyed() {
            eventBus.$off('sys-user-popup')
        },
        methods: {
            onSearch(value){
                if(value.length==0){
                    this.users=cloneDeep(this.usersClone)
                }else{
                    this.users=this.users.filter(item => item.realName.indexOf(value)>=0)
                }

            },
            auditConfirm() {

            },
            back() {

            },
            onLoad() {
                getUsers().then(res => {
                    if (res.success) {
                        this.users = res.data
                        this.usersClone=cloneDeep(this.users)
                    }
                    // 加载状态结束
                    this.loading = false
                    this.finished = true
                })
            },
            selectUser (item) {
                this.show = false
                eventBus.$emit('selectUser',item)
            },
        }
    }
</script>

<style scoped>

</style>


